<template>

	<div class="row justify-content-center">            
        <div class="col-lg-5 col-md-7 mt-6">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                   
                    <form role="form">
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Company"
                                    addon-left-icon="ni ni-building"
                                    v-model="form.company" readonly>
                        </base-input>

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Usuario"
                                    addon-left-icon="ni ni-single-02"
                                    v-model="form.user">
                        </base-input>

                        <base-input class="input-group-alternative"
                                    placeholder="Contraseña"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="form.pass">
                        </base-input>

                        <div class="text-center">
                            <!-- <base-button type="primary btn-block" class="mt-4 mb-2" @click="loginApollo()">Ingresar</base-button> -->
                            <base-button type="primary btn-block" class="mt-4 mb-2" @click="loginAgente()">Ingresar</base-button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
	
</template>

<script>
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
    import gql from 'graphql-tag';
    // import { onLogin } from '../../apollo.graphql'
	export default {
		data() {
			return {
				form: {
					company: process.env.VUE_APP_COMPANY_AGENTE,
					user: '',
					pass: '',
                    url: process.env.VUE_APP_API_URL_AGENTE,
				}
			}
		},
		computed: {
			...mapGetters('auth', ['homePage']),
            url() {
                return this.$route.query.url
            },
           
		},
		methods: {
			...mapActions('validatetoken', ['login', 'authToken']),
			loginAgente() {
                this.login(this.form)
				.then((resp) => {
                if (this.url){
                    window.location.href = this.url
                } else {
                    this.$router.push({ name: 'resultado' })
                }
				
				}).catch((error) => {
					console.log('error: ', error)
				})
            },
              loginApollo() {

                this.$apollo.mutate({
                    // Query
                    mutation: gql`mutation{
                            login(data: {
                                company: "devportal",
                                user: "jreyes",
                                pass: "jean123",
                                url: "https://apidev.beaware360.com/ba360",
                                type: "back" 
                            }){
                                token,
                                usuario{
                                user
                            },
                                url,
                                company
                            }
                        }`,
                    // Parameters

                }).then((data) => {
                    // Result
                    this.$store.commit('validatetoken/setInstance', data.data.login)
                    // onLogin(this.$apollo.provider.defaultClient, data.data.login)
                        this.$router.push({ name: 'resultado' })
                }).catch((error) => {
                    // Error
                    console.error(error)
                    // We restore the initial user input
                })
             },
		},
        mounted() {
            //'YmVhMzYwIGpyZXllcyBqZWFuMTIzIHlCeWdPcktxQTAgMjAyMDAyMDc='
            this.authToken({
                url: process.env.VUE_APP_API_URL_AGENTE,
                company: process.env.VUE_APP_COMPANY_AGENTE,
                token: 'ZGV2cG9ydGFsIGdtZWRpbmEgZ21lZGluYTIgeUJ5Z09yS3FBMCAyMDIwMD'
            })
            .then(() => {
                console.log("entra");
                // this.getAll(true, null, 'mounted')
                this.$router.push({name: 'resultado'})
            }).catch(() => {
                console.log("no entra");
                let urlPath = window.location.pathname
                //this.$router.push({ name: 'loginitg', query: { url: urlPath } })
            })
        },
	}	
</script>